<script lang="ts">
	import blocks from "@assets/icons/blocks.svg?raw";
	import hydratation from "@assets/icons/hydratation.svg?raw";
	import place from "@assets/icons/place.svg?raw";
	import restore from "@assets/icons/restore.svg?raw";
	import stimulation from "@assets/icons/stimulation.svg?raw";
	import Formatted from "../common/Formatted.svelte";
	import Icon from "../common/Icon.svelte";

	const benefits = [
		{
			icon: restore,
			title: "Obnova vlasové struktury",
		},
		{
			icon: stimulation,
			title: "Stimulace vlasového růstu",
		},
		{
			icon: hydratation,
			title: "Hloubková výživa a hydratace",
		},
		{
			icon: blocks,
			title: "Posílení a regenerace vlasů",
		},
		{
			icon: place,
			title: "Salón u náměstí v Karviné",
		},
	];
</script>

<section class="container-12">
	<div class="container-center pt-6 sm:pt-8 md:pt-[6rem]">
		<div class="flex flex-wrap justify-center items-start gap-4 sm:gap-5 md:gap-6 xl:gap-8">
			{#each benefits as benefit (benefit.title)}
				<div
					class="flex flex-col items-center gap-3 sm:gap-3 md:gap-4 w-[calc(50%-0.5rem)] sm:w-[calc(50%-0.625rem)] md:w-[calc(33.333%-1rem)] lg:w-[calc(20%-1.2rem)] xl:flex-1"
				>
					<div
						class="w-16 h-16 sm:w-16 sm:h-24 md:w-16 md:h-24 rounded-2xl sm:rounded-[1.75rem] md:rounded-[2rem] bg-ivory-100 flex items-center justify-center border-2 border-ivory-400"
					>
						<Icon icon={benefit.icon} class="w-7 h-7 sm:w-7 sm:h-7 md:w-8 md:h-8 text-midnight" />
					</div>
					<p class="text-center text-xs sm:text-sm md:text-md text-hazelnut-500 leading-[1.4] px-1">
						<Formatted text={benefit.title} />
					</p>
				</div>
			{/each}
		</div>
	</div>
</section>
